import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {supplierFirmographicsUrl} from "~/pages/supplier-360/services/supplier360PdlUrls";
import type {SupplierFirmographics} from "~/pages/supplier-360/types/Supplier360PdlTypes";

/** The latest company-data snapshot for one entity, or `undefined` when none has ever been retrieved. */
export function useSupplierFirmographicsQuery(entityId: number | undefined) {
    const url = supplierFirmographicsUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierFirmographics>>(url)).data.results[0],
        enabled: Boolean(entityId),
    });
}
